import { connect } from 'react-redux';
import Participants from 'project/components/participants';

const mapStateToProps = (state) => {
  const { participants } = state.project.creatives;

  return {
    items: participants
  };
}

export default connect(mapStateToProps)(Participants);



// WEBPACK FOOTER //
// ./project/containers/participants.js